export const VGS_URL = 'https://js.verygoodvault.com/vgs-show/2.2.0/show.js';
